module.exports = __webpack_public_path__ + "img/slideImage_hondou.136a6db2.jpg";